export default {
      id: "login-sj-usage",
      viewBox: "0 0 19 15",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-sj-usage",
      toString: function () {
        return this.url;
      }
    }